<template>
  <v-form
    ref="form"
    lazy-validation
    class="pa-4 px-4"
    @submit.prevent="createBrand"
  >
    <div class="d-flex justify-end">
      <v-btn
        tile
        color="primary"
        @click="$router.push({ name: 'brand-index' })"
      >
        <v-icon left>
          arrow_back
        </v-icon>
        Back
      </v-btn>
    </div>
    <v-row>
      <v-col offset-lg="4" offset-md="4" md="4" sm="12">
        <div class="text-center">
          <v-text-field
            :rules="nameRules"
            label="Name"
            v-model="brand.name"
            required
          ></v-text-field>

          <image-picker
            v-model="brand.logo"
            :uploaded="brand.logo !== null"
            class="mb-5"
            @delete-item="brand.logo = null"
            @reset="brand.logo = null"
          >
            <div slot="activator" class="cursor-pointer w-100 h-100">
              <img
                :src="brand.logo"
                alt="avatar"
                width="100%"
                height="100%"
                v-if="brand.logo"
              />
            </div>
          </image-picker>
          <v-btn type="submit" class="mx-0 mt-4">Update</v-btn>
        </div>
      </v-col>
    </v-row>
  </v-form>
</template>
<script>
import ImagePicker from "@/components/ImagePicker.vue";
import { mapState } from "vuex";
export default {
  props: ["id"],
  data() {
    return {
      rules: [
        value =>
          !value ||
          value.size < 2000000 ||
          "Avatar size should be less than 2 MB!"
      ],
      nameRules: [
        v => !!v || "Name is required",
        v => (v && v.length >= 5) || "Name must be at least 5 characters",
        v =>
          (v && v.length <= 35) || "Name must be less than than 35 characters"
      ]
    };
  },
  computed: {
    ...mapState({
      brand: state => state.brands.brand
    })
  },
  components: {
    ImagePicker
  },
  async mounted() {
    await this.$store.dispatch("brands/LOAD_BRAND", {
      productBrandId: this.id
    });
  },
  methods: {
    async createBrand() {
      if (this.$refs.form.validate()) {
        this.$swal({
          title: "Updating product brand...",
          html: "this will only take a moment...",
          icon: "info",
          didOpen: () => {
            this.$swal.showLoading();
          }
        });
        await this.$store.dispatch("brands/UPDATE_BRAND", this.brand);
        this.$swal.close();
        this.$swal({
          title: "Success",
          html: "Product brand has been updated",
          icon: "info"
        });
      }
    }
  }
};
</script>
